import createStore from 'unistore'

const initialState = {}

export const store = createStore(initialState)
